import { createStore } from "vuex";
import api from "../api";

export default createStore({
  state: {
    bookType: null,
    pageType: null,
    coverType: null,
    sizeType: null,
    formatType: null,
    selectedDesign: null,
    selectedDesignIndex: null,
    colourOption: null,
    selectedFilter: null,
    bookDesigns: [],
    styleFilters: [],
    loading: false,
    rootPath: "",
    storeCode: "gb",
    categories: {}
  },
  getters: {
    filtersJSONForResults: state => {
      let filters = {};

      if (state.selectedFilter) {
        filters.styles = [state.selectedFilter.name];
      }

      if (state.coverType && state.formatType?.categoryId !== 911) {
        // Daily Diaries only have one cover type, so this filter doesn't exist on the category
        filters = {
          ...filters,
          ...state.coverType.filters[state.storeCode]
        };
      }

      if (state.sizeType) {
        filters = {
          ...filters,
          ...state.sizeType.filters[state.storeCode]
        };
      }

      return JSON.stringify(filters);
    },
    categoryIdForResults: state => {
      if (
        state.pageType &&
        state.bookType.categoryId === 73 &&
        state.coverType.key === "hard-back"
      ) {
        return state.pageType.categoryId;
      }

      if (state.formatType) {
        return state.formatType.categoryId;
      }

      return state.bookType.categoryId;
    }
  },
  actions: {
    replaceDesignWithOption({ commit, state }, { updatedDesign, index }) {
      const updatedDesigns = [...state.bookDesigns];
      updatedDesigns[index] = updatedDesign;
      commit("setBookDesigns", updatedDesigns);
      commit("setSelectedDesign", updatedDesign);
    },
    setResultsAndFilters({ state, commit }, data) {
      const parsedBuilderData = JSON.parse(data.builder_json);
      commit("setBookDesigns", parsedBuilderData);
      commit("setStyleFilters", data.style_filters);

      // This will assign the first design[0] from the builderData to the selectedDesign state, but will only be assigned on the initial fetch for the designs
      if (!state.selectedDesign) {
        commit("setSelectedDesign", parsedBuilderData[0]);

        if (parsedBuilderData[0].colour_options) {
          commit("setColourOption", parsedBuilderData[0].colour_options[0]);
        }
      }

      setTimeout(() => {
        const htmlChanged = new Event("htmlChanged");
        window.dispatchEvent(htmlChanged);
      }, 100);
    },
    async fetchDesigns({ commit, dispatch, getters }) {
      commit("setLoading", true);

      try {
        const params = {
          category_id: getters.categoryIdForResults,
          filters: getters.filtersJSONForResults
        };

        const { data } = await api.post("/book-builder/data", params, {
          headers: {
            "Content-Type": "application/json"
          }
        });

        dispatch("setResultsAndFilters", data);

        commit("setLoading", false);
      } catch (error) {
        console.log(error);
        commit("setBookDesigns", []);
      }
    }
  },
  mutations: {
    setBookType(state, bookType) {
      state.bookType = bookType;
    },
    setPageType(state, pageType) {
      state.pageType = pageType;
    },
    setCoverType(state, coverType) {
      state.coverType = coverType;
    },
    setSizeType(state, sizeType) {
      state.sizeType = sizeType;
    },
    setFormatType(state, formatType) {
      state.formatType = formatType;
    },
    setBookDesigns(state, designs) {
      state.bookDesigns = designs;
    },
    setSelectedDesign(state, design) {
      state.selectedDesign = design;
    },
    setSelectedFilter(state, filter) {
      state.selectedFilter = filter;
    },
    setStyleFilters(state, filters) {
      state.styleFilters = filters;
    },
    setColourOption(state, colour) {
      state.colourOption = colour;
    },
    setLoading(state, flag) {
      state.loading = flag;
    },
    setRootPath(state, path) {
      state.rootPath = path;
    },
    setStoreCode(state, code) {
      state.storeCode = code;
    },
    setCategories(state, categories) {
      state.categories = categories;
    }
  }
});
